import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classes", "styles", "heading", "subHeading", "body", "dataCy"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var Information = function Information(_ref) {
  var classes = _ref.classes,
      styles = _ref.styles,
      heading = _ref.heading,
      subHeading = _ref.subHeading,
      body = _ref.body,
      dataCy = _ref.dataCy,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    className: classes && classes.container,
    style: styles && styles.container
  }, props), {}, {
    "data-cy": dataCy,
    children: [/*#__PURE__*/_jsx("h1", {
      className: classNames("font-serif text-2xl mb-0 ws-pre-line ".concat(classes && classes.heading), {
        'display-none': !heading
      }),
      children: heading
    }), subHeading && /*#__PURE__*/_jsx("p", {
      className: classNames("h2 mt-6 ws-pre-line ".concat(classes && classes.subHeading), {
        'display-none': !subHeading
      }),
      children: subHeading
    }), body && /*#__PURE__*/_jsx("p", {
      className: classNames("h4 font-sans leading-6 mb-0 ws-pre-line ".concat(classes && classes.body, " ").concat(styles && styles.body, "\n            }"), {
        'display-none': !body
      }),
      children: body
    })]
  }));
};